module.exports = __webpack_public_path__ + "static/media/data-point-layers.37681fc9.svg";